export enum TeamMemberTabs {
   AssignedTasks = 0,
   TaskRatings = 1,
   TrainingPlans = 2,
   ManagerNotes = 3,
   LeadershipAssignments = 4,
   DirectReports = 5,
}
